var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Line",
    width: 24,
    height: 24,
    "data-name": "Icon - Line",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:#3ace01}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2466",
    fill: "none",
    d: "M0 0H24V24H0z",
    "data-name": "Rectangle 2466"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_5903",
    "data-name": "Group 5903",
    transform: "translate(-105.618 -228.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8017",
    d: "M112.893 232.618h9.451a3.284 3.284 0 0 1 3.275 3.275v9.451a3.284 3.284 0 0 1-3.275 3.275h-9.451a3.284 3.284 0 0 1-3.275-3.275v-9.451a3.284 3.284 0 0 1 3.275-3.275z",
    className: "prefix__cls-2",
    "data-name": "Path 8017"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8018",
    fill: "#fff",
    d: "M165.411 295.194c3.242 0 5.87 2.1 5.87 4.7a4.017 4.017 0 0 1-.876 2.471 1.211 1.211 0 0 1-.109.136 5.085 5.085 0 0 1-.638.637c-1.623 1.5-4.3 3.287-4.648 3.011-.307-.24.5-1.411-.431-1.606l-.2-.025c-2.75-.391-4.838-2.314-4.838-4.628 0-2.59 2.628-4.696 5.87-4.696z",
    "data-name": "Path 8018",
    transform: "translate(-47.809 -59.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8019",
    d: "M210.8 376.388h1.184a.307.307 0 0 0 .306-.306v-.026a.307.307 0 0 0-.306-.306h-.852v-1.939a.307.307 0 0 0-.306-.306h-.026a.307.307 0 0 0-.306.306v2.271a.307.307 0 0 0 .306.306zm7.336-1.423v-.026a.307.307 0 0 0-.306-.306h-.852v-.485h.852a.307.307 0 0 0 .306-.306v-.026a.307.307 0 0 0-.306-.306h-1.184a.307.307 0 0 0-.306.306v2.271a.307.307 0 0 0 .306.306h1.184a.307.307 0 0 0 .306-.306v-.026a.307.307 0 0 0-.306-.306h-.852v-.485h.852a.307.307 0 0 0 .306-.306zm-2.277 1.332a.306.306 0 0 0 .089-.215v-2.271a.307.307 0 0 0-.306-.306h-.025a.307.307 0 0 0-.306.306v1.333l-1.111-1.484a.307.307 0 0 0-.266-.155h-.026a.307.307 0 0 0-.306.306v2.271a.307.307 0 0 0 .306.306h.026a.307.307 0 0 0 .306-.306v-1.358l1.115 1.522a.312.312 0 0 0 .022.031.258.258 0 0 0 .119.088.3.3 0 0 0 .116.023h.026a.3.3 0 0 0 .143-.036.216.216 0 0 0 .075-.055zm-3.016.091h.026a.307.307 0 0 0 .306-.306v-2.271a.307.307 0 0 0-.306-.306h-.026a.307.307 0 0 0-.306.306v2.271a.307.307 0 0 0 .305.306z",
    className: "prefix__cls-2",
    "data-name": "Path 8019",
    transform: "translate(-96.602 -134.92)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLine);
export default __webpack_public_path__ + "static/media/icon-line.28a5e13af326ad2e67f17d16b2228e2f.svg";
export { ForwardRef as ReactComponent };